import { type RoleState, roleState } from "./roles";

export type AccessStoreRelation = "admin" | "writer" | "drafter" | "reader";
export type ManagementStoreRelation = "owner" | "maintainer" | "viewer";

// The Bifrost colour of a role or access type. The colours are defined once, in
// lib/roles; `store` is kept for the callers that name where the relation is
// from, and does not change the colour, as the role names do not overlap.
export function relationBadgeState(
  relation: string,
  _store?: "access" | "management",
): RoleState {
  return roleState(relation);
}
